var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../classes/runtime/Runtime';
import { AppStageRun } from './AppStageRun';
let AppStage = class AppStage extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (app.appMode.isInEditMode) {
            if (!runtime.streamedPackages.Edit)
                return null;
            const EditAppStage = runtime.solidPackages.Edit.components.EditAppStage;
            return React.createElement(EditAppStage, { app: app });
        }
        return React.createElement(AppStageRun, { app: app });
    }
};
AppStage = __decorate([
    observer
], AppStage);
export { AppStage };
